import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '@/store/useStore';

export function LearningProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token } = useStore();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
